export enum EDNIModalRoutes {
  ENTRY = 'entry',
  DNI_SCAN = 'dni-scan',
  PERSONAL_DATA = 'personal-data',
  OPERATION_SHIPPING = 'operation-shipping',
  OPERATION_SHIPPING_FINISHED = 'operation-shipping-finished',
  LABOR_DATA = 'labor-data',
  SIGNATURE = 'signature',
  TPV = 'tpv',
  EXISTING_PAYMENT_SELECTOR = 'existing-payment-selector',
  UNKNOWN_ERROR = 'unknown-error',
  DENIAL = 'denial',
  TIMEOUT = 'timeout',
  END = 'end',
  PERSONAL_FINANCES_UNAVAILABLE = 'personal-finances-unavailable',
  EXISTING_RFN = 'existing-refinanced-loan',
}
